<template>
  <v-app>
    <router-view />
    <AppSnackbar :event-bus="eventBus" />
  </v-app>
</template>

<script>
import { AppSnackbar } from 'ipro-ui-kit-vuejs/src/components/base';
import EventBus from './event-bus';

export default {
  components: {
    AppSnackbar,
  },
  data() {
    return {
      eventBus: EventBus,
    };
  },
  computed: {
    splashScreenDiv() {
      return document.querySelector('.splash-screen');
    },
  },
  created() {
    this.eventBus.$on('app-loaded', this.hideSplashScreen);
    this.eventBus.$on('show-splash-screen', this.showSplashScreen);
    this.updateVersionMetadata();
  },
  methods: {
    hideSplashScreen() {
      this.splashScreenDiv.style.display = 'none';
    },
    showSplashScreen() {
      this.splashScreenDiv.style.display = 'block';
    },
    updateVersionMetadata() {
      const appVersionMetadata = document.querySelector('meta#app-version');
      appVersionMetadata.content = GLOBALS.VERSION_STRING.trim();
    },
  },
};
</script>
